<template>
  <div>
    <div class="header">
      <div class="header_title">
        <div class="header_lef">
          <div class="header_btn" @click="handleCollapse()">
            <div v-if="!collapse" class="f-16">
              <menu-fold-outlined/>
            </div>
            <div v-else class="f-16">
              <menu-unfold-outlined/>
            </div>
          </div>
        </div>
        <div class="header_rig">
          <div class="rig-one">
            <router-link to="/landlord/set/base">
              <setting-outlined
                  style="font-size: 20px; color: #666666; margin-top: 6px"
              />
            </router-link>
          </div>
          <a-popover trigger="click">
            <div class="user-info">
              <a-avatar :size="30" :src="avatarUrl"></a-avatar>
              <div class="rig-name">
                {{ nickName }}
              </div>
              <caret-down-outlined/>
            </div>
            <template #content>
              <div class="popover-row" @click="outLogin">退出登录</div>
            </template>
          </a-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {CaretDownOutlined, MenuFoldOutlined, MenuUnfoldOutlined, SettingOutlined,} from "@ant-design/icons-vue";
import store from "@/store/pms/landlord/index";
import {computed, onMounted, ref, watch} from "vue";
import router from "@/router/index";
import {userLogOut} from "@/api/api"; //接口
export default {
  components: {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    CaretDownOutlined,
    SettingOutlined,
  },
  setup() {
    const collapse = computed(() => {
      return store.state.collapseSign;
    });
    // const breadCrumb = computed(() => {
    //   return store.getters.getBreadCrumb;
    // });
    let screenWidth = ref(document.body.clientWidth);
    let nickName = ref(JSON.parse(sessionStorage.getItem("landlordInfo")).nickname);
    let avatarUrl = ref(JSON.parse(sessionStorage.getItem("landlordInfo")).avatar);
    watch(screenWidth, (newValue) => {
      if (Number(newValue) < 1000) {
        store.commit("handleCollapse", true);
      } else {
        store.commit("handleCollapse", false);
      }
    });

    function handleCollapse() {
      store.commit("handleCollapse", !collapse.value);
    }

    function outLogin() {
      userLogOut().then(() => {
        sessionStorage.removeItem("landlordInfo");
        sessionStorage.removeItem("companyInfo");
        store.getters.cleanRouter;
        router.replace("/");
      });
    }

    onMounted(() => {
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth;
          screenWidth.value = window.screenWidth;
        })();
      };
    });

    return {
      handleCollapse,
      collapse,
      outLogin,
      nickName,
      //   breadCrumb,
      avatarUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  box-shadow: 0 5px 5px #e6e6e655;

  .header_title {
    padding: 0 30px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header_lef {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 24px;

      .header_btn {
        cursor: pointer;
        margin-right: 10px;
      }
    }

    .header_rig {
      display: flex;
      align-items: center;

      .rig-one {
        margin-right: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
      }

      .user-info {
        justify-content: flex-end;
        font-size: 14px;
        cursor: pointer;
        display: flex;
        align-items: center;

        .rig-name {
          margin: 0 5px;
          font-weight: bold;
        }
      }
    }
  }
}

.popover-row {
  padding: 5px;

  &:hover {
    color: #1890ff;
    cursor: pointer;
  }
}
</style>
